export const INSTANT_SEARCH_RATE_LIMIT_ERROR = 'Too many requests';

export const INSTANT_SEARCH_EXPIRED_SESSION_ERROR =
  '"validUntil" parameter expired (less than current date)';

export const INSTANT_SEARCH_API_ERRORS = [
  {
    instantSearchError: INSTANT_SEARCH_RATE_LIMIT_ERROR,
    message: 'Search limit reached',
    body: "You've reached the limit for the number of searches that can be made. Please try again later.",
  },
  {
    instantSearchError: INSTANT_SEARCH_EXPIRED_SESSION_ERROR,
    message: 'Your search session has expired',
    body: "To keep things secure, we've ended your session. A quick refresh will get you going again.",
  },
];
